export const nl_NL = {
  general: {
    error: {
      pageNotFound: "Pagina niet gevonden.",
      somethingWentWrong: "Er is iets misgegaan.",
      noDataFound: "Geen data gevonden.",
    },
    text: {
      backToHomePage: "Terug naar hoofdpagina",
      select: "Selecteer",
      back: "Terug",
      previous: "Vorige",
      next: "Aankomende",
    },
  },
  header: {
    home: "Hoofdpagina",
    members: "Leden",
    events: "Evenementen",
    photos: "Foto's",
    contact: "Contact",
    settings: "Instellingen",
  },
  home: {
    title: "Hoofdpagina",
    informations: {
      latestVideo: {
        title: "Laatste video",
        description: "Hieronder zie je onze laatste video van Next Generation.",
      },
      members: {
        title: "Wie zijn wij?",
        description:
          "Welkom op onze website! Wij zijn Next Generation, een Nederlandse christelijke band uit de omgeving Harderwijk, Ermelo en Putten. Wij spelen met alle liefde voor God's koninkrijk en wij doen dit al sinds 2021!",
        buttonLabel: "Ga naar ledenpagina",
      },
      events: {
        title: "Wanneer spelen wij?",
        description:
          "Wij spelen vooral in onze eigen kerk - NGK De Oever in Ermelo. Soms spelen we ook ergens anders, dit kan je zien bij de pagina Evementen op deze website. Hier kan je ook meer informatie vinden!",
        buttonLabel: "Ga naar evenementenpagina",
      },
      contact: {
        title: "Hoe kom je in contact met ons?",
        description:
          "Je kan via verschillende wegen contact met ons nemen. Je kan via social media een berichtje sturen, maar je kan ook een contactformulier invullen bij de pagina Contact. Hier kan je ook onze social media vinden.",
        buttonLabel: "Ga naar contactpagina",
      },
    },
  },
  members: {
    title: "Leden",
    description:
      "Hier kan je zien wie de bandleden zijn van Next Generation. Ook kan je per bandlid een stukje informatie zien.",
    memberDescription: (firstName: any, age: any, role: any) => {
      return `Hoi! Ik ben ${firstName} en ik ben
      ${age} jaar oud. Ik ben de 
      ${role} van Next
      Generation. Als je vragen hebt voor mij kan je een contactformulier invullen!`;
    },
    age: "Leeftijd",
    instrument: "Instrument",
    role: "Rol",
  },
  events: {
    title: "Evenementen",
    location: "Locatie",
    time: "Tijd",
    description: "Hieronder zie je de aankomende optredens die wij hebben.",
    futureEvents: "Aankomende evenementen",
    previousEvents: "Vorige evenementen",
  },
  photos: {
    title: "Foto's",
    description: "Hieronder zie je foto's die van ons gemaakt zijn.",
  },
  contact: {
    title: "Contact ons",
    popup: "Bericht is succesvol verzonden!",
    description:
      "Als je ons wilt contacteren, vul hieronder je gegevens in en laat een bericht achter! Of volg ons op social media!",
    form: {
      subject: "Onderwerp",
      email: "E-mail",
      message: "Bericht",
      submit: "Verzend bericht",
    },
  },
  settings: {
    title: "Instellingen",
    description: "Hier kan je je eigen persoonlijke instellingen aanpassen.",
  },
  construction: {
    title: "In onderhoud",
    pageDescription: "Deze pagina is op dit moment in ondehoud!",
    description:
      "Deze website is op dit moment in onderhoud. We zijn binnenkort terug met een nieuwe website.",
  },
};
